<template>
    <v-container class="d-flex flex-column justify-center align-center container">
        <splash-loading />
    </v-container>

</template>

<script>

import { ROUTE_PROSPECT_LOCATION } from '../../router/routes';

const SplashLoading = () => import('../components/utils/SplashLoading.vue');

export default {

    components: { SplashLoading },

    name: 'Splash',

    async mounted() {

        

        this.waitingTime()
        
    },

    methods: {

        waitingTime(){

            setTimeout(() => { 

                this.$router.push(ROUTE_PROSPECT_LOCATION) 

            }, 3000);

        },

    },
}

</script>

<style scoped>

.container {

    margin-top: 15%;

}

@media all and (min-width: 700px) {
    .container {

        margin-top: 5%;

    }
}

</style>

